
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./swiftguard-html.json") })
        }
      }, "path---swiftguard-html");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---swiftguard-html!./.cache/json/swiftguard-html.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---swiftguard-html!./.cache/json/swiftguard-html.json
// module chunks = 45